module.exports = __webpack_public_path__ + "images/emoji/cake.b8e1f6b081797dadacfc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cake.png
// module id = ZQh6
// module chunks = 13